const setElementProps = void 0;
export { setElementProps };
//# sourceMappingURL=setElementProps.mjs.map
